import React from 'react';
import useI18n from '../../i18n/useI18n';
import RoleBasedAccess from '../role-based-access';
import { UserTypeEnum } from '../../utils/enums';
import './style.scss';

const PreferenceDateCard = ({
    data,
    onEdit,
    onDelete,
    onView
}) => {
    const { t } = useI18n();
    const {
        universityName,
        academicYear,
        period1,
        period2,
        period3,
        raw
    } = data;

    const universityLogo = raw.university?.logoUrl || raw.university?.logo || '/assets/images/logo-placeholder.png';
    console.log("ra", raw, universityLogo);
    const renderPeriod = (periodData, index) => {
        if (!periodData || !periodData.start) return null;

        return (
            <div className="period-item" key={index}>
                <div className="period-title">
                    {t(`DATE_SCENARIO_TABLE_COLUMN_PERIOD${index}`)}
                </div>
                <div className="period-date">
                    <i className="zmdi zmdi-calendar-alt"></i>
                    {periodData.label}
                </div>
                {periodData.announcement && (
                    <div className="announcement-date">
                        <i className="zmdi zmdi-notifications-active text-info"></i>
                        {t('DATE_SCENARIO_ANNOUNCEMENT')}: {periodData.announcementLabel}
                    </div>
                )}
            </div>
        );
    };

    const hasPeriods = (period1?.start) || (period2?.start) || (period3?.start);

    return (
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 mb-3">
            <div className="preference-date-card">
                <div className="card-header-section">
                    <img
                        src={universityLogo}
                        alt={universityName}
                        className="uni-logo"
                        onError={(e) => { e.target.src = '/assets/images/logo-placeholder.png'; }}
                    />
                    <div className="uni-info">
                        <h5 title={universityName}>{universityName}</h5>
                        <span className="academic-year">{academicYear} {t('COMMON_YEAR')}</span>
                    </div>
                </div>

                <div className="card-body-section">
                    {!hasPeriods && (
                        <div className="text-center text-muted p-2">
                            <i className="zmdi zmdi-calendar-close mb-1" style={{ fontSize: '20px' }}></i>
                            <p style={{ fontSize: '12px', margin: 0 }}>{t('DATE_SCENARIO_NO_DATES_SET')}</p>
                        </div>
                    )}
                    {renderPeriod(period1, 1)}
                    {renderPeriod(period2, 2)}
                    {renderPeriod(period3, 3)}
                </div>

                <div className="card-footer-section">
                    {onView && (
                        <button
                            type="button"
                            className="btn btn-sm btn-info btn-icon btn-round m-r-5"
                            onClick={(e) => {
                                e.stopPropagation();
                                onView(data);
                            }}
                            title={t('DATE_SCENARIO_TABLE_ACTION_VIEW')}
                        >
                            <i className="zmdi zmdi-eye"></i>
                        </button>
                    )}
                    <RoleBasedAccess allowedRoles={[UserTypeEnum.ADMIN]}>
                        <button
                            type="button"
                            className="btn btn-sm btn-warning btn-icon btn-round m-r-5"
                            onClick={(e) => {
                                e.stopPropagation();
                                onEdit(data);
                            }}
                            title={t('DATE_SCENARIO_TABLE_ACTION_EDIT')}
                        >
                            <i className="zmdi zmdi-edit"></i>
                        </button>
                        <button
                            type="button"
                            className="btn btn-sm btn-danger btn-icon btn-round"
                            onClick={(e) => {
                                e.stopPropagation();
                                onDelete(data);
                            }}
                            title={t('DATE_SCENARIO_TABLE_ACTION_DELETE')}
                        >
                            <i className="zmdi zmdi-delete"></i>
                        </button>
                    </RoleBasedAccess>
                </div>
            </div>
        </div>
    );
};

export default PreferenceDateCard;
